import type { Video } from "@/types/video";

export const videos: Video[] = [
  {
    id: "v01",
    title: "顶流男星深夜现身机场全程被护送，随行阵容引全网猜测",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20red%20neon%20airport%20hall%20at%20night%20with%20abstract%20spotlight%20beams%20and%20blurred%20crowd%20silhouettes%2C%20moody%20dramatic%20crimson%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20desaturated%20palette&width=800&height=450&seq=video-01&orientation=landscape",
    categoryId: "star-latest",
    publishDate: "2026-10-15",
    duration: "08:24",
    views: 1284000,
    source: "黑料视频·现场组",
    excerpt:
      "凌晨抵达的机场却被数十人层层护送，随行工作人员数量远超常规，这场深夜行程究竟藏着什么？",
    description:
      "本期视频完整梳理了顶流男星深夜抵达机场的全过程。从机舱出口到保姆车驶离，随行团队规模、路线安排与现场围观群众的反应都被镜头记录了下来。我们同时比对了过去半年的公开行程，试图解释这次出行为何如此低调又如此高规格。视频中不涉及任何未获证实的私人信息，仅就已公开的现场画面进行客观呈现。",
    tags: ["机场路透", "行程", "顶流"],
  },
  {
    id: "v02",
    title: "女团成员疑似更换经纪公司，合约细节被网友逐条扒出",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20neon%20pink%20and%20crimson%20record%20label%20studio%20background%20with%20glowing%20contract%20paper%20shapes%20and%20soft%20bokeh%20lights%2C%20moody%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20magazine%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-02&orientation=landscape",
    categoryId: "net-buzz",
    publishDate: "2026-10-15",
    duration: "06:10",
    views: 963000,
    source: "黑料视频·资讯组",
    excerpt:
      "一条工商变更信息引发连锁反应，粉丝从公开资料里扒出了合约期限、分成比例等关键线索。",
    description:
      "一条看似普通的公开工商信息变更，在粉丝圈里掀起了不小的讨论。本期视频把网友们扒出的公开资料做了系统整理：公司架构变化、经纪合约常见的年限与分成区间、以及艺人与原公司合作关系的公开时间线。所有内容均来自可公开查询的资料，视频只做信息归集，不对任何私人合约内容下结论。",
    tags: ["经纪公司", "合约", "女团"],
  },
  {
    id: "v03",
    title: "暑期档古装大剧片场花絮曝光，主演互动笑翻整个剧组",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20film%20set%20at%20golden%20hour%20with%20red%20lanterns%20and%20silk%20banners%2C%20warm%20crimson%20and%20amber%20toned%20cinematic%20lighting%2C%20deep%20shadows%2C%20no%20text%20no%20faces%2C%20epic%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-03&orientation=landscape",
    categoryId: "hot-review",
    publishDate: "2026-10-14",
    duration: "11:02",
    views: 1756000,
    source: "黑料视频·剧组探班",
    excerpt:
      "一场本该严肃的宫斗戏，硬是被两位主演演成了搞笑现场，导演笑到直接喊卡三次。",
    description:
      "本期带你直击暑期档古装大剧的片场。服化道团队如何在有限预算里还原朝代质感、演员们在紧张的拍摄间隙如何互相打趣、以及一条被 NG 三次的名场面究竟是怎么拍出来的，视频里都有完整记录。我们还在片场捕捉到了几处容易被观众忽略的小道具细节。",
    tags: ["古装剧", "片场花絮", "暑期档"],
  },
  {
    id: "v04",
    title: "影帝新片一镜到底长镜头背后，摄影指导亲自拆解调度",
    cover:
      "https://readdy.ai/api/search-image?query=Studio%20camera%20rig%20silhouette%20against%20deep%20red%20gradient%20backdrop%20with%20light%20diffusion%20and%20lens%20flare%2C%20moody%20premium%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-04&orientation=landscape",
    categoryId: "deep-insight",
    publishDate: "2026-10-13",
    duration: "18:47",
    views: 742000,
    source: "黑料视频·深度部",
    excerpt:
      "长达六分钟的不间断长镜头到底怎么完成？摄影指导从走位、光源到声音同步逐层讲解。",
    description:
      "影帝新片中有一段长达六分钟的一镜到底，被观众称为全片最震撼的段落。本期我们邀请到幕后摄影指导，从镜头运动轨迹、灯光如何随演员移动、到现场收音与演员走位的精确配合，完整拆解这段长镜头的实现过程。视频同时展示了几组幕后工作照与分镜草图，帮助你理解电影工业流程。",
    tags: ["电影", "长镜头", "幕后"],
  },
  {
    id: "v05",
    title: "综艺名场面复盘：嘉宾现场互怼，弹幕直接刷爆",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20colorful%20variety%20show%20stage%20with%20neon%20ring%20lights%20and%20crimson%20gradient%20backdrop%2C%20playful%20energetic%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-05&orientation=landscape",
    categoryId: "star-latest",
    publishDate: "2026-10-13",
    duration: "09:33",
    views: 1108000,
    source: "黑料视频·综艺组",
    excerpt:
      "一段不足一分钟的对话让当期综艺冲上热搜，我们把前因后果和现场气氛完整还原。",
    description:
      "本期复盘近期最火的一档综艺名场面。两位嘉宾在游戏环节里的针锋相对并非剧本，而是临场反应的碰撞。视频梳理了当期节目从开场到冲突爆发的完整脉络，也分析了剪辑节奏如何放大了这段火花。末尾还附上了几条被网友反复截取的细节镜头。",
    tags: ["综艺", "名场面", "热搜"],
  },
  {
    id: "v06",
    title: "演唱会门票十秒售罄，粉丝应援大屏被路人围观拍照",
    cover:
      "https://readdy.ai/api/search-image?query=Concert%20stadium%20at%20night%20with%20red%20laser%20beams%20and%20huge%20blurred%20stage%20lights%2C%20fans%20glowstick%20bokeh%2C%20dramatic%20crimson%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-06&orientation=landscape",
    categoryId: "net-buzz",
    publishDate: "2026-10-12",
    duration: "05:18",
    views: 869000,
    source: "黑料视频·现场组",
    excerpt:
      "开票十秒就被清空，场馆外自发的应援大屏反而成了当晚最大的打卡点。",
    description:
      "一场热门演唱会的开票把售票系统挤到崩溃，粉丝自发在场馆周边投放的应援大屏，意外吸引了大量路人驻足拍照。本期视频记录了开场前两小时的场馆氛围、应援物料的创意设计，以及购票系统在超高并发下的表现。内容以现场观察为主，不带节奏。",
    tags: ["演唱会", "应援", "开票"],
  },
  {
    id: "v07",
    title: "短剧顶流爆红背后，单集成本与拍摄周期全揭秘",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20short%20drama%20shooting%20set%20with%20deep%20red%20neon%20lighting%20and%20abstract%20phone%20screen%20shapes%2C%20modern%20fast%20paced%20cinematic%20mood%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-07&orientation=landscape",
    categoryId: "hot-review",
    publishDate: "2026-10-11",
    duration: "12:56",
    views: 934000,
    source: "黑料视频·深度部",
    excerpt:
      "几分钟一集的短剧为何能霸榜？我们从预算、周期到投流模式做了完整梳理。",
    description:
      "短剧赛道过去一年热度居高不下，本期视频聚焦一部现象级短剧的诞生过程：单集拍摄周期通常只有一到两天、演员与场景如何高效复用、以及平台投流在爆红过程中扮演的角色。视频基于公开的行业访谈与制作方披露的信息整理，帮助你理解短剧这门生意的逻辑。",
    tags: ["短剧", "成本", "行业观察"],
  },
  {
    id: "v08",
    title: "导演剪辑版与院线版到底差在哪？逐场对比全解析",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20overlapping%20film%20frames%20on%20a%20deep%20red%20gradient%20background%20with%20light%20leaks%20and%20grain%20texture%2C%20moody%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-08&orientation=landscape",
    categoryId: "deep-insight",
    publishDate: "2026-10-10",
    duration: "21:09",
    views: 658000,
    source: "黑料视频·影评组",
    excerpt:
      "多出来的二十多分钟到底讲了什么？被删掉的支线如何改变了结局的味道。",
    description:
      "导演剪辑版上线后，关于它与院线版差异的讨论就没停过。本期视频逐场对比两个版本：新增的人物支线、被调整的时间顺序、以及结局处理上的微妙变化，如何让整部电影的情感落点完全不同。视频观点仅供参考，鼓励你先看完两个版本再下判断。",
    tags: ["导演剪辑版", "影评", "结局"],
  },
  {
    id: "v09",
    title: "音乐节压轴嘉宾临时换人，现场粉丝真实反应被拍下",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20main%20stage%20at%20dusk%20with%20red%20and%20orange%20lighting%2C%20crowd%20silhouettes%20and%20smoke%2C%20dramatic%20moody%20cinematic%20mood%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-09&orientation=landscape",
    categoryId: "net-buzz",
    publishDate: "2026-10-09",
    duration: "07:41",
    views: 903000,
    source: "黑料视频·现场组",
    excerpt:
      "演出开始前一小时突然换人，观众席从骚动到欢呼的全过程都被记录了下来。",
    description:
      "音乐节压轴时段临时更换嘉宾，是今年现场演出里最受关注的一次突发状况。本期视频按时间线还原了消息传到观众席后的反应、主办方的现场广播处理方式，以及替补嘉宾登台后气氛如何被重新点燃。视频不针对任何个人进行评价。",
    tags: ["音乐节", "突发", "现场"],
  },
  {
    id: "v10",
    title: "新晋小花红毯造型盘点，造型师角度点评每一套",
    cover:
      "https://readdy.ai/api/search-image?query=Red%20carpet%20walkway%20with%20deep%20crimson%20spotlights%20and%20abstract%20glittering%20sequin%20texture%2C%20elegant%20moody%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20fashion%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-10&orientation=landscape",
    categoryId: "star-latest",
    publishDate: "2026-10-08",
    duration: "10:27",
    views: 812000,
    source: "黑料视频·时尚组",
    excerpt:
      "从廓形到配色，本期邀请造型师从专业角度聊聊红毯上那些被夸和被吐槽的造型。",
    description:
      "新晋小花近来的红毯造型讨论度一路走高。本期视频邀请到从业多年的造型师，从剪裁比例、面料质感、配饰与妆发的整体协调等角度，逐一解读几套高关注度造型的优劣。内容为专业观点分享，不含对艺人本人的评价。",
    tags: ["红毯", "造型", "时尚"],
  },
  {
    id: "v11",
    title: "悬疑剧结局彩蛋逐帧拆解，被忽略的隐藏线索引热议",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20mystery%20corridor%20with%20deep%20red%20lighting%20and%20a%20single%20glowing%20door%20edge%2C%20suspenseful%20cinematic%20atmosphere%2C%20grain%20texture%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-11&orientation=landscape",
    categoryId: "hot-review",
    publishDate: "2026-10-07",
    duration: "14:15",
    views: 1421000,
    source: "黑料视频·影评组",
    excerpt:
      "大结局里一闪而过的三个镜头，其实早就埋好了下一季的伏笔。",
    description:
      "悬疑剧收官后，结局彩蛋成了讨论最热的话题。本期视频把最后三分钟逐帧放慢，指出几处容易被忽略的画面细节与道具重复出现的规律，并解释它们为什么可能指向下一季的剧情走向。视频属于观众向解读，欢迎在评论区提出不同看法。",
    tags: ["悬疑剧", "彩蛋", "结局解读"],
  },
  {
    id: "v12",
    title: "综艺剪辑风波持续发酵，后期团队首次公开回应",
    cover:
      "https://readdy.ai/api/search-image?query=Editing%20timeline%20screen%20glow%20in%20a%20dark%20studio%20with%20deep%20red%20accent%20lighting%20and%20abstract%20waveform%20graphics%2C%20moody%20tech%20cinematic%20mood%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-12&orientation=landscape",
    categoryId: "net-buzz",
    publishDate: "2026-10-06",
    duration: "08:52",
    views: 776000,
    source: "黑料视频·资讯组",
    excerpt:
      "一段被剪掉的关键画面，让节目组陷入了舆论漩涡，后期团队给出了怎样的解释？",
    description:
      "综艺播出后，一段疑似被剪辑掉的对话引发了巨大争议。本期视频整理了节目组与后期团队公开回应的要点，并结合综艺剪辑的常规流程，说明素材取舍通常受时长、节奏与审核等多重因素影响。视频只呈现已公开信息，不替任何一方站队。",
    tags: ["综艺", "剪辑", "争议"],
  },
  {
    id: "v13",
    title: "老牌歌手复出巡演舞台设计幕后，每一束光都有讲究",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20under%20construction%20with%20warm%20amber%20and%20deep%20red%20lighting%2C%20abstract%20truss%20and%20rigging%20shapes%2C%20moody%20cinematic%20mood%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-13&orientation=landscape",
    categoryId: "star-latest",
    publishDate: "2026-10-05",
    duration: "13:38",
    views: 598000,
    source: "黑料视频·现场组",
    excerpt:
      "复出巡演的舞台被观众称为艺术品，这次我们拍到了搭建现场和灯光编程过程。",
    description:
      "老牌歌手复出巡演的舞台设计一票难求。本期视频记录了两天的舞台搭建过程：可升降的模块化结构、上百组灯具的编程逻辑，以及灯光如何配合不同曲目切换情绪。视频中还出现了几段彩排花絮，帮助观众理解一场演唱会的技术含量。",
    tags: ["演唱会", "舞台设计", "复出"],
  },
  {
    id: "v14",
    title: "票房黑马诞生记：一部小成本电影的营销逆袭复盘",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20box%20office%20ticket%20stub%20abstract%20shapes%20on%20a%20deep%20red%20gradient%20background%20with%20spotlights%2C%20moody%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-14&orientation=landscape",
    categoryId: "deep-insight",
    publishDate: "2026-10-04",
    duration: "17:24",
    views: 521000,
    source: "黑料视频·深度部",
    excerpt:
      "没有大明星、没有高预算，它怎么在强片环伺的档期里杀出一条路？",
    description:
      "一部小成本电影成为这个档期最大的黑马。本期视频从点映口碑扩散、短视频二创引流、到影院排片逐步提升的过程，复盘了它逆袭的完整路径。我们也采访了参与宣发的从业者，聊了聊在预算有限时营销资源应该优先投在哪里。",
    tags: ["电影", "票房", "营销"],
  },
  {
    id: "v15",
    title: "影视基地探班：道具组如何在三天内还原一座古装宅院",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20courtyard%20film%20set%20with%20warm%20amber%20lanterns%20and%20deep%20red%20wooden%20columns%2C%20cinematic%20golden%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-15&orientation=landscape",
    categoryId: "hot-review",
    publishDate: "2026-10-03",
    duration: "12:03",
    views: 466000,
    source: "黑料视频·剧组探班",
    excerpt:
      "从板材到成品只用三天，道具组的效率和多层做旧手法让人看得直呼过瘾。",
    description:
      "本期走进影视基地的道具车间。道具组分享了如何在极短的工期内完成一座古装宅院的搭建：模块化板材的快速拼接、多层做旧与烟火熏色的质感处理，以及可拆卸结构如何方便转场。视频里出现的每一件道具都有它自己的使用逻辑。",
    tags: ["道具", "探班", "古装"],
  },
  {
    id: "v16",
    title: "主播转型演员首部作品上线，演技表现引发大讨论",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20setup%20with%20deep%20red%20ring%20light%20glow%20and%20abstract%20camera%20shapes%2C%20moody%20cinematic%20mood%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=800&height=450&seq=video-16&orientation=landscape",
    categoryId: "net-buzz",
    publishDate: "2026-10-02",
    duration: "09:47",
    views: 689000,
    source: "黑料视频·影评组",
    excerpt:
      "从直播间到镜头前，这条路并不好走，本期聊聊跨界演员的真实表现。",
    description:
      "一位人气主播转型出演的首部作品上线后，评价两极分化。本期视频从台词、情绪递进与镜头表现三个维度，相对具体地拆解了其中的几个关键片段，也聊了聊跨界演员普遍会遇到的适应难题。视频观点仅供参考，欢迎有自己的判断。",
    tags: ["跨界", "主播", "演技"],
  },
  {
    id: "v17",
    title: "颁奖礼后台直击：艺人在候场时的真实状态被记录",
    cover:
      "https://readdy.ai/api/search-image?query=Backstage%20corridor%20of%20an%20award%20ceremony%20with%20deep%20red%20curtains%20and%20warm%20gold%20accent%20lighting%2C%20elegant%20moody%20cinematic%20mood%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-17&orientation=landscape",
    categoryId: "star-latest",
    publishDate: "2026-10-01",
    duration: "06:55",
    views: 733000,
    source: "黑料视频·现场组",
    excerpt:
      "聚光灯之外，后台那些准备上台的瞬间，往往比舞台本身更有意思。",
    description:
      "颁奖礼的后台永远比台前更热闹。本期视频记录了艺人在候场区的准备状态：补妆、对稿、互相打气，以及与工作人员的高效配合。视频呈现的是公开活动场合中可以被记录的日常片段，不涉及任何私人内容。",
    tags: ["颁奖礼", "后台", "花絮"],
  },
  {
    id: "v18",
    title: "纪录片镜头下的群演生活，导演谈创作的取舍与克制",
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20film%20crew%20with%20deep%20red%20sunset%20backlight%20and%20abstract%20handheld%20camera%20shapes%2C%20gritty%20moody%20cinematic%20mood%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-18&orientation=landscape",
    categoryId: "deep-insight",
    publishDate: "2026-09-30",
    duration: "22:36",
    views: 412000,
    source: "黑料视频·深度部",
    excerpt:
      "一部关于群演的纪录片为什么能打动那么多人？导演聊了聊镜头背后的克制。",
    description:
      "本期访谈一部长纪录片《群演》的导演。影片把镜头对准了影视城里每天等待机会的普通人，全程没有旁白、没有煽情配乐，却让不少观众看到落泪。导演分享了拍摄三年间的取舍、与被拍摄者建立信任的过程，以及纪录片创作者应有的克制。",
    tags: ["纪录片", "导演访谈", "群演"],
  },
];

export default videos;